import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import { ContentService } from 'src/app/views/content/content.service';
import { NotesService } from 'src/app/views/displayer/notes/notes.service';
import { PathService } from 'src/app/views/displayer/path/path.service';
import { AppService } from '../../../app.service';
import { MaterialModule } from '../../material.module';
import { ToastService } from '../toast/toast.service';

interface LanguageData {
  icon;
  value;
  viewValue;
}

@Component({
  selector: 'app-add-section',
  templateUrl: './add-section.component.html',
  styleUrls: ['./add-section.component.scss'],
  standalone: true,
  imports: [MaterialModule, TranslateModule, FormsModule],
})
export class AddSectionComponent implements OnInit {
  datatext;
  lecture;
  section;
  newBlogDescription;
  newBlogName;
  blogDescription;
  course;
  blog;
  lectureName;
  sectionName;
  courseName;
  blogName;
  newCourseName;
  newCourseDescription;
  selectedLanguage = this.translate.currentLang || 'fr';
  loading = false;
  translateSub: Subscription;
  group;
  note;
  buttonLock = false;
  newNoteName = '';
  newNoteDescription = '';
  pathName;
  pathDescription;
  pathID;
  selectedContentType: 'course' | 'blog' | null = 'course';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private toast: ToastService,
    public dialogRef: MatDialogRef<AddSectionComponent>,
    private errorHandler: ErrorHandlerService,
    private translate: TranslateService,
    private noteService: NotesService,
    private pathService: PathService,
    private contentService: ContentService
  ) {}

  ngOnInit() {
    if (this.data.type.includes('path')) {
      this.pathName = this.data.name;
      this.pathDescription = this.data.description;
      this.pathID = this.data._id;
    } else if (this.data.type.includes('note')) {
      if (this.data.noteID) {
        this.noteService
          .getNote(this.data.noteID)
          .then((note: any) => {
            this.note = note;
            this.newNoteDescription = note.description;
            this.newNoteName = note.name;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    } else if (this.data.type === 'choose-content-type') {
      // The HTML will handle the display based on data.type
    } else {
      if (this.data.courseID) {
        this.contentService.getTheCourse(this.data.courseID).subscribe({
          next: (course) => {
            this.loading = false;
            this.course = course;
            this.newCourseDescription = course.description;

            this.newCourseName = course.name;
            this.onLangChange();

            if (this.data.sectionID) {
              for (const section of this.course.sections) {
                if (section._id == this.data.sectionID) {
                  this.section = section;
                  if (this.section.__name) {
                    this.section.actualName = this.section.__name.editions.find((edition) => edition.language == this.selectedLanguage).content;
                  }
                  this.sectionName = this.section.actualName || this.section.name;
                }
                if (this.data.lectureID) {
                  for (const lecture of section.lectures) {
                    if (lecture._id == this.data.lectureID) {
                      this.lecture = lecture;
                      if (this.lecture.__name) {
                        this.lecture.actualName = this.lecture.__name.editions.find((edition) => edition.language == this.selectedLanguage).content;
                      }
                      this.lectureName = this.lecture.actualName || this.lecture.name;
                    }
                  }
                }
              }
            }
          },
          error: (err) => {
            this.toast.snackbar.open(this.translate.instant('Snackbar.CreatingCourseFail'), 'Ok', { duration: 2000 });
          },
        });
      } else if (this.data.type.includes('set')) {
        this.loading = true;
        if (this.data.type.includes('blog')) {
          this.contentService.getBlogPost(this.data.blogID).then((blog) => {
            this.loading = false;
            this.blog = blog;
            this.newBlogDescription = blog.description;
            this.newBlogName = blog.name;
            this.onLangChange();
          });
        }
      }
    }
  }

  generateContentEmbedding(contentID) {
    this.contentService.generateContentEmbeddingAction(contentID);
    this.dialogRef.close();
  }

  onLangChange() {
    if (this.course) {
      if (this.course.__name) {
        this.newCourseName = this.course.__name.editions.find((edition) => edition.language == this.selectedLanguage).content;
      }
      if (this.course.__description) {
        this.newCourseDescription = this.course.__description.editions.find((edition) => edition.language == this.selectedLanguage).content;
      }

      if (this.section && this.section.__name) {
        this.section.actualName = this.section.__name.editions.find((edition) => edition.language == this.selectedLanguage).content;
      }
      if (this.section) {
        this.sectionName = this.section.actualName || this.section.name;
      }

      if (this.lecture && this.lecture.__name) {
        this.lecture.actualName = this.lecture.__name.editions.find((edition) => edition.language == this.selectedLanguage).content;
      }
      if (this.lecture) {
        this.lectureName = this.lecture.actualName || this.lecture.name;
      }
    }
    if (this.blog) {
      if (this.blog.__name) {
        this.newBlogName = this.blog.__name.editions.find((edition) => edition.language == this.selectedLanguage).content;
      }
      if (this.blog.__description) {
        this.newBlogDescription = this.blog.__description.editions.find((edition) => edition.language == this.selectedLanguage).content;
      }
    }
  }


  editCourse(type) {
    this.buttonLock = true;
    const params = {
      _id: this.course._id,
      name: type == 'title' ? this.newCourseName : this.course.name,
      category: this.course.category,
      description: type != 'title' ? this.newCourseDescription : this.course.description,
      type,
      language: this.course.__name ? this.selectedLanguage : undefined,
    };

    this.contentService.editCourse(params).subscribe(
      (res) => {
        this.toast.snackbar.open(this.translate.instant('Snackbar.Done'), 'Ok', {
          duration: 2000,
        });
        this.dialogRef.close('ok');
      },
      (err) => {
        this.buttonLock = false;

        if (!this.errorHandler.handle401Error(err)) {
          this.toast.snackbar.open(this.translate.instant('Snackbar.CreatingCourseFail'), 'Ok', { duration: 2000 });
        }
      }
    );
  }

  editBlog(type) {
    this.buttonLock = true;
    const params = {
      _id: this.blog._id,
      name: this.newBlogName,
      category: this.blog.category,
      description: this.newBlogDescription,
      language: this.blog.__name ? this.selectedLanguage : undefined,
    };

    this.contentService.editBlog(params).subscribe(
      (res) => {
        this.toast.snackbar.open(this.translate.instant('Snackbar.Done'), 'Ok', {
          duration: 2000,
        });
        this.dialogRef.close('ok');
      },
      (err) => {
        this.buttonLock = false;
        if (!this.errorHandler.handle401Error(err)) {
          this.toast.snackbar.open(this.translate.instant('Snackbar.EditingBlogFail'), 'Ok', { duration: 2000 });
        }
      }
    );
  }


  createCourse() {
    this.buttonLock = true;

    this.contentService
      .createCourse({
        name: this.courseName,
        description: this.newCourseDescription,
        language: this.translate.currentLang || 'fr',
      })
      .subscribe({
        next: () => {
          this.toast.showWithoutHeader({ level: 'success', text: this.translate.instant('Snackbar.KnowledgeCreated') });
          this.dialogRef.close('ok');
        },
        error: (err) => {
          this.buttonLock = false;
          if (err.error && err.error.msg) {
            if (err.error && err.error.msg.msg == 'alreadyExists') {
              this.toast.showWithoutHeader({ level: 'error', text: this.translate.instant('Snackbar.CourseAlreadyExistMsg') });
            }
          } else if (!this.errorHandler.handle401Error(err)) {
            this.toast.showWithoutHeader({ level: 'error', text: this.translate.instant('Snackbar.CreatingCourseFail') });
          }
        },
      });
  }

  createBlog() {
    this.buttonLock = true;

    this.contentService
      .createBlog({
        name: this.blogName,
        description: this.blogDescription,
        language: this.translate.currentLang,
      })
      .subscribe(
        (res) => {
          this.toast.snackbar.open(this.translate.instant('Snackbar.Done'), 'Ok', {
            duration: 2000,
          });

          this.dialogRef.close('ok');
        },
        (err) => {
          this.buttonLock = false;

          if (err.error && err.error.msg) {
            if (err.error && err.error.msg.msg == 'alreadyExists') {
              this.toast.snackbar.open(this.translate.instant('Snackbar.BlogAlreadyExistMsg'), 'Ok', { duration: 2000 });
            }
          } else if (!this.errorHandler.handle401Error(err)) {
            this.toast.snackbar.open(this.translate.instant('Snackbar.CreatingBlogFail'), 'Ok', { duration: 2000 });
          }
        }
      );
  }
  createNote() {
    this.noteService
      .createNote({
        name: this.newNoteName,
        description: this.newNoteDescription,
      })
      .subscribe({
        complete: () => {
          this.noteService.sendNoteEvent('new-note');
          this.toast.snackbar.open(this.translate.instant('Snackbar.Done'), 'Ok', {
            duration: 2000,
          });
          this.dialogRef.close();
        },
        error: (err) => {
          this.errorHandler.handle401Error(err);
          console.error(err);
          this.dialogRef.close();
        },
      });
  }

  editNote() {
    this.loading = true;
    this.noteService
      .editNote({
        _id: this.note._id,
        name: this.newNoteName,
        description: this.newNoteDescription,
      })
      .subscribe({
        complete: () => {
          this.loading = true;
          this.noteService.sendNoteEvent('edit-note');
          this.toast.snackbar.open(this.translate.instant('Snackbar.Done'), 'Ok', {
            duration: 2000,
          });
          this.dialogRef.close(true);
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  createPath() {
    this.loading = true;
    this.pathService
      .createPath({
        name: this.pathName,
        description: this.pathDescription,
      })
      .subscribe({
        next: () => {
          this.pathService.emitPathEvent();
          this.loading = false;
          this.dialogRef.close();
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
        },
      });
  }
  editPath() {
    this.loading = true;
    this.pathService
      .editPath({
        name: this.pathName,
        description: this.pathDescription,
        _id: this.pathID,
      })
      .subscribe({
        next: () => {
          this.pathService.emitPathEvent();
          this.loading = false;
          this.dialogRef.close();
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
        },
      });
  }

  get currentName(): string {
    return this.selectedContentType === 'course' ? this.courseName : this.blogName;
  }

  set currentName(val: string) {
    if (this.selectedContentType === 'course') {
      this.courseName = val;
    } else {
      this.blogName = val;
    }
  }

  get currentDescription(): string {
    return this.selectedContentType === 'course' ? this.newCourseDescription : this.blogDescription;
  }

  set currentDescription(val: string) {
    if (this.selectedContentType === 'course') {
      this.newCourseDescription = val;
    } else {
      this.blogDescription = val;
    }
  }

  onSubmit() {
    if (this.selectedContentType === 'course') {
      this.createCourse();
    } else if (this.selectedContentType === 'blog') {
      this.createBlog();
    }
  }
}
